import { render, staticRenderFns } from "./AddCustomEmail.vue?vue&type=template&id=068ee8ec"
import script from "./AddCustomEmail.vue?vue&type=script&lang=js"
export * from "./AddCustomEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports